import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import styles from './EditAccountModal.module.scss';
import Button from '../../common/Button';
import Input from '../../blocks/Input';
import PhoneInput from '../../blocks/PhoneInput';
import { requiredValidator, emailValidator, isFormValid } from '../../../utils/validators';

class EditAccountModal extends PureComponent {
  validators = [
    {
      key: 'name',
      validator: [requiredValidator],
    },
    {
      key: 'admin_contact.email',
      validator: [requiredValidator, emailValidator],
    },
    {
      key: 'billing_contact.email',
      validator: [requiredValidator, emailValidator],
    },
  ];

  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  initialState() {
    const { retailer } = this.props;

    const newRetailer = {
      name: retailer.name,
      website: retailer.website,
      admin_contact: retailer.admin_contact,
      billing_contact: retailer.billing_contact,
    };

    return {
      form: newRetailer,
    };
  }

  handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name.indexOf('.') > 0) {
      const [section, field] = name.split('.');

      this.setState((prevState) => {
        return {
          form: {
            ...prevState.form,
            [section]: {
              ...prevState.form[section],
              [field]: value,
            },
          },
        };
      });
    } else {
      this.setState((prevState) => {
        return {
          form: {
            ...prevState.form,
            [name]: value,
          },
        };
      });
    }
  };

  handlePhoneChange = (section, value) => {
    this.setState((prevState) => {
      return {
        form: {
          ...prevState.form,
          [section]: {
            ...prevState.form[section],
            phone: value,
          },
        },
      };
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    this.props.saveInfo(this.state.form);
    this.props.onClose();
  };

  resetForm = () => {
    this.setState(this.initialState());
    this.props.onClose();
  };

  buttonIsDisabled() {
    return !isFormValid(this.state.form, this.validators);
  }

  render() {
    const { open = false } = this.props;
    const { form } = this.state;

    return (
      <ModalWindow open={open} onClose={this.resetForm}>
        <form onSubmit={this.handleSubmit}>
          <h2>Edit profile</h2>

          <div className={styles.body}>
            <section>
              <label>
                <span>Company name</span>
                <Input
                  name="name"
                  type="text"
                  value={form.name}
                  placeholder="Company name"
                  onChange={this.handleChange}
                  validate={[requiredValidator]}
                />
              </label>
              <label>
                <span>Website address</span>
                <Input
                  name="website"
                  type="text"
                  value={form.website}
                  placeholder="example.com"
                  onChange={this.handleChange}
                />
              </label>
            </section>

            <hr />

            <div className={styles.two_columns}>
              <section>
                <h3>Business Contact Information</h3>
                <label>
                  <span>First Name</span>
                  <Input
                    name="admin_contact.first_name"
                    type="text"
                    value={form.admin_contact.first_name}
                    onChange={this.handleChange}
                  />
                </label>
                <label>
                  <span>Last Name</span>
                  <Input
                    name="admin_contact.last_name"
                    type="text"
                    value={form.admin_contact.last_name}
                    onChange={this.handleChange}
                  />
                </label>
                <label>
                  <span>Email address</span>
                  <Input
                    name="admin_contact.email"
                    type="text"
                    value={form.admin_contact.email}
                    placeholder="mail@mail.com"
                    onChange={this.handleChange}
                    validate={[requiredValidator, emailValidator]}
                  />
                </label>
                <label>
                  <span>Phone number</span>
                  <PhoneInput
                    value={form.admin_contact.phone}
                    placeholder="Phone Number"
                    onChange={(event) => this.handlePhoneChange('admin_contact', event.target.value)}
                  />
                </label>
              </section>

              <section>
                <h3>Billing Contact Information</h3>
                <label>
                  <span>First Name</span>
                  <Input
                    name="billing_contact.first_name"
                    type="text"
                    value={form.billing_contact.first_name}
                    onChange={this.handleChange}
                  />
                </label>
                <label>
                  <span data-testid="billing-contact-last-name-label">Last Name</span>
                  <Input
                    name="billing_contact.last_name"
                    type="text"
                    data-testid="input-billing-contact-last-name-value"
                    value={form.billing_contact.last_name}
                    onChange={this.handleChange}
                  />
                </label>
                <label>
                  <span>Email address</span>
                  <Input
                    name="billing_contact.email"
                    type="text"
                    value={form.billing_contact.email}
                    placeholder="mail@mail.com"
                    onChange={this.handleChange}
                    validate={[requiredValidator, emailValidator]}
                  />
                </label>
                <label>
                  <span>Phone number</span>
                  <PhoneInput
                    name="billing_contact.phone"
                    value={form.billing_contact.phone}
                    placeholder="Enter phone number"
                    onChange={(event) => this.handlePhoneChange('billing_contact', event.target.value)}
                  />
                </label>
              </section>
            </div>
          </div>

          <div className={styles.footer}>
            <Button type="submit" text="SAVE" disabled={this.buttonIsDisabled()} />
            <Button color="white" text="CANCEL" onClick={this.resetForm} />
          </div>
        </form>
      </ModalWindow>
    );
  }
}

export default EditAccountModal;

EditAccountModal.propTypes = {
  retailer: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  saveInfo: PropTypes.func.isRequired,
};
